module.exports = __webpack_public_path__ + "img/earth-zh-m.accd41c5.png";